export default "__VITE_ASSET__86525bec__"